import { createFredrickLocalRepository } from 'fredrick-local-repository';

/** One IndexedDB-backed local Fredrick library for this browser profile. */
export const localRepository = createFredrickLocalRepository();
